<template>
    <q-card>
        <q-card-section class="no-padding">
            <q-banner class="bg-blue text-white" inline-actions>
                بارگذاری سند
                <template v-slot:action>
                    <q-btn flat round icon="close" v-close-popup/>
                </template>
            </q-banner>
        </q-card-section>
        <q-card-section class="q-pa-xs">
            <q-banner rounded class="bg-amber-2 text-amber-10">
                لازم است فایل ضمیمه در فرمت pdf باشد.
            </q-banner>
        </q-card-section>
        <q-card-section class="no-padding">
            <UploadFile @uploaded-finish="finishUploaded" remote-path="BuyOrders"
                        :file-kind="fileKind"
                        :file-name="`${filename.toString()}`"/>
        </q-card-section>
    </q-card>
</template>

<script>
import {mapActions} from "vuex";
import UploadFile from "@/components/OwnCloud/UploadFile.vue";

export default {
    name: "BuyFacLisAttachment",
    props: {
        filename: {
            type: String,
            required: true
        },
        fileKind: {
            type: Number,
            required: true
        }
    },
    data() {
        return {}
    },
    components: {UploadFile},
    methods: {
        ...mapActions({
            setAttachmentFlag: 'Buys/setFactorAttachmentFlag'
        }),
        finishUploaded(args) {
            this.setAttachmentFlag({Buy_Num: args.filename, Buy_Kind: args.fileKind, flag: 1}).then(() => {
                this.$emit('uploaded_finish', args)
            })
        },
    },
    computed: {},
    watch: {},
    created() {

    }
}
</script>

<style scoped>

</style>